<template>
  <section @click.self="changeMask" :class="[showMask?'show':'','mask-wrap']">
    <transition name="showmask-ordermodel">
      <div v-if="showMask" :class="['mask-container']">
        <header>
          <div class="thumbnail-wrap">
            <img src="static/img/1.jpg" alt="goodsImg">
          </div>
          <div class="text-description">
            <h3>各大机场,提前抢购!</h3>
            <p class="red-text">
              <span class="">会员价 :<i class="iconfont icon-renminbi"></i>500.00</span>
              <span class="yuanjia">原价 :<i class="iconfont icon-renminbi"></i>800.00</span>
            </p>
          </div>
          <div @click="changeMask" class="del-icon-wrap">
            <i class="iconfont icon-shanchu2"></i>
          </div>
        </header>

        <section class="select-container-wrap">

          <div class="select-item-wrap">

            <div class="airport-wrap">
              <h3>机场 :</h3>
              <div class="airport-items">
                <button :class="[currentAir === index?'active':'']" v-for="(item,index) in airports" @click="airActive(item,index)"
                  :key="index">{{item.name}}</button>
              </div>
            </div>

            <div class="car-model">
              <h3>车辆类型 :</h3>
              <button v-for="(item,index) in carModels" :key='index' :class="[currentCar === index ? 'active':'']" @click="carActive(index)">{{item.name}}</button>
            </div>

            <div class="ticket-form">
              <h3>用车方式 :</h3>
              <button v-for="(item,index) in ticketForm" :key='index' @click="ticActive(index)" :class="[currentTicketForm === index?'active':'']">中山往返机场套票</button>
            </div>

          </div>

          <div class="goods-amount">
            <span><em style="color: #E22222;">*</em>购买数量 :</span>
            <div class="selector">
              <i @click="subGoods(1)" :class="['iconfont','icon-jianhao',submitInfo.goodsAmount == 1 ?'disabled':'']"></i>
              <input v-model="submitInfo.goodsAmount" type="number" disabled="disabled">
              <i @click="addGoods(1)" :class="['iconfont','icon-jiahao',submitInfo.goodsAmount >= 9?'disabled':'']"></i>
            </div>
          </div>

          <div :class="['link-man-wrap']">
            <span><em style="color: #E22222;">*</em>联系人</span>
            <input v-model="submitInfo.linkMan" placeholder="请输入联系人" type="text" />
          </div>

          <div :class="['phone-num-wrap']">
            <span><em style="color: #E22222;">*</em>联系电话</span>
            <input v-model="submitInfo.phone" placeholder="输入您的联系电话" type="number">
          </div>

          <div :class="['user-site']">
            <span><em style="color: #E22222;">*</em>乘车地址</span>
            <input v-model="submitInfo.userSite" placeholder="请输入乘车地址" type="text" />
          </div>

          <div class="date-picker" @click="setDate">
            <span><em style="color: #E22222;">*</em>用车日期</span>
            <span :class="[submitInfo.bookDate==''?'gray-text':'']">
              {{submitInfo.bookDate == "" ? '请选择预订日期':submitInfo.bookDate}}
            </span>
          </div>

          <div class="time-picker" @click="setTime">
            <span><em style="color: #E22222;">*</em>用车时间</span>
            <span :class="[submitInfo.bookTime==''?'gray-text':'']">
              {{submitInfo.bookTime==""? '请选择用车时间':submitInfo.bookTime}}
            </span>
          </div>

          <div :class="['leave-msg']">
            <span><em style="color: #E22222;">*</em>买家留言</span>
            <input v-model="submitInfo.leaveMsg" placeholder="输入留言信息" type="text" />
          </div>


          <!-- <div class="checkboxs">
            <label>Vue
              <input type="checkbox" value="test1" v-model="frameType">
            </label>
            <label>node
              <input type="checkbox" value="test2" v-model="frameType">
            </label>
            <label>React
              <input type="checkbox" value="test3" v-model="frameType">
            </label>
            <label>Angular4
              <input type="checkbox" value="test4" v-model="frameType">
            </label>
          </div>

          <ul>
            <li v-for="frame in frameType">
              {{frame}}
            </li>
          </ul> -->

        </section>

        <footer class="mask-footer">
          <button @click="goToSubmitOrder">下一步</button>
        </footer>

      </div>
    </transition>
  </section>
</template>

<script>

  import weui from 'weui.js'
  import 'weui'

  export default {
    name: "mask-public",
    props: {
      showMask: {
        type: Boolean,
        required: false,
      },
    },
    data() {
      return {
        // frameType: [],
        //用户输入的资料
        submitInfo: {
          linkMan: "",
          phone: "",
          bookDate: "",
          bookTime: "",
          leaveMsg:"",
          userSite: "",
          goodsAmount: 1,
        },

        airports: [{
            id: 1,
            name: "广州机场"
          },
          {
            id: 2,
            name: "深圳机场"
          },
          {
            id: 3,
            name: "珠海机场"
          },
        ],

        carModels: [{
          id: 1,
          name: "红旗H7"
        }, ],

        ticketForm: [{
          id: 1,
          name: "中山往返机场套票"
        }],

        currentAir: 0,
        currentCar: 0,
        currentTicketForm: 0,

        // setTimeTomorrow:"",
      }
    },
    created() {

    },
    methods: {
      airActive(item, index) {
        if (this.currentAir != index) {
          this.currentAir = index;
        } else {
          alert("最少选择一个选项!");
        }
      },
      carActive(index) {
        if (this.currentCar != index) {
          this.currentCar = index;
        } else {
          alert("最少选择一个选项!");
        }
      },
      ticActive(index) {
        if (this.currentTicketForm != index) {
          this.currentTicketForm = index;
        } else {
          alert("最少选择一个选项!");
          // this.currentTicketForm = -1;
        }
      },
      addGoods(inc) {
        if (this.submitInfo.goodsAmount < 10) {
          this.submitInfo.goodsAmount += inc;
        } else {
          alert("如需购买更多数量请联系客服订购,电话:88880777");
          this.submitInfo.goodsAmount = 10;
        }
      },
      subGoods(dec) {
        if (this.submitInfo.goodsAmount > 1) {
          this.submitInfo.goodsAmount -= dec;
        } else if (this.submitInfo.goodsAmount == 1) {
          alert("商品数量不能少于1~");
          this.submitInfo.goodsAmount = 1;
        }
      },

      changeMask() {
        this.$emit("triggerMask", "showMask");
      },


      setDate() {
        let that = this;
        var myDate = new Date();
            myDate.setDate(myDate.getDate()+1);
        weui.datePicker({
          start: myDate,
          end: new Date().getFullYear(),
          // defaultValue:myDate,
          onConfirm: function(result) {
            that.submitInfo.bookDate = result[0].value + "-" + result[1].value + "-" + result[2].value;
          },
        });
      },

      setTime() {
        let _this = this;
        var hours = [],
            minites = [],
            symbol = [{label: ':',value: 0}];
        if (!hours.length) {
          for (let i = 0; i < 24; i++) {
            var hours_item = {};
            hours_item.label = ('' + i).length === 1 ? '0' + i : '' + i;
            hours_item.value = i;
            hours.push(hours_item);
          }
        }
        if (!minites.length) {
          for (let j = 0; j < 60; j++) {
            var minites_item = {};
            minites_item.label = ('' + j).length === 1 ? '0' + j : '' + j;
            minites_item.value = j;
            minites.push(minites_item);
          }
        }
        weui.picker(hours, symbol, minites, {
          onConfirm: function(result) {
            _this.submitInfo.bookTime = result[0].label + ':' + result[2].label;
          },
        });
      },



      // 跳转-------------------
      goToSubmitOrder() {
        let linkManReg = /^[\u4e00-\u9fa5_a-zA-Z]{2,20}$/,
            phoneReg = /^[1][3,4,5,7,8][0-9]{9}$/,
            linkManBoolean = linkManReg.test(this.submitInfo.linkMan),
            phoneBoolean = phoneReg.test(this.submitInfo.phone);

        if (this.submitInfo.linkMan && this.submitInfo.phone && this.submitInfo.bookDate && this.submitInfo.bookTime) {
          if (linkManBoolean) {
            if (phoneBoolean) {
              if (phoneBoolean && linkManBoolean) {
                this.$router.push({
                  name: "submit-order",
                  params: {
                    submitInfo: this.submitInfo,
                  }
                });
              }
            } else {
              alert("手机号码不合法");
            }
          } else {
            alert("名字不合法");
          }
        } else {
          alert("请补充填写完整资料");
        }

      },
    }
  }
</script>

<style scoped lang="less">

  @import "../../style/variable.less";

  .mask-wrap {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    opacity: 0;
    transition: all .4s;
    background-color: rgba(0, 0, 0, .5);
    z-index: -1;
    .flex_wrap(flex-end, initial, nowrap, column);
    &.show {
      opacity: 1;
      z-index: 999;
    }
  }

  // .show-Mask-Wrap-enter,.show-Mask-Wrap-leave-to{
  // 	opacity: 0;
  // }
  // .show-Mask-Wrap-leave,.show-Mask-Wrap-enter-to{
  // 	opacity: 1;
  // }
  // .show-Mask-Wrap-enter-active,.show-Mask-Wrap-leave-active{
  // 	transition: .4s;
  // }

  .showmask-ordermodel-enter,
  .showmask-ordermodel-leave-to {
    transform: translate3d(0, 100%, 0);
    opacity: .5;
  }

  .showmask-ordermodel-leave,
  .showmask-ordermodel-enter-to {
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }

  .showmask-ordermodel-enter-active,
  .showmask-ordermodel-leave-active {
    transition: .4s;
  }

  // .showMask-OrderModel-enter-to{
  // 	transform: translate3d(0,0,0);
  // 	opacity: 1;
  // }
  // .showMask-OrderModel-leave-to{
  //   transform: translate3d(0,100%,0);
  // 	opacity: 0;
  // }

  .mask-container {
    background-color: #fff;
    height: 80%;
    .flex_wrap(initial, initial, initial, column);

    &.show {
      overflow: visible;
      transform: translateY(0);
    }

    .select-container-wrap {
      flex: 1;
      .overfA();

      &>div:last-child {
        margin-bottom: 10%;
      }
    }

    header,
    .select-item-wrap {
      width: 95%;
      margin-left: auto;
    }

    header {
      .flex_wrap(space-around, center, nowrap, initial);
      padding: 10px 0;
      .border-B();

      .thumbnail-wrap {
        margin-right: 3%;

        img {
          // margin-top: -20%;
          width: 1.6rem;
          height: 1.6rem;
          padding: 3%;
          background-color: #fff;
          border: 1px solid #888;
        }
      }

      .text-description {
        flex: 1;
        .yuanjia{
          .gray-text();
          .line-thr();
          margin-left:5px;
        }
        h3 {
          font-weight: 600;
          color: #333;
          font-size: @fz+.04rem;
        }
        &>p {
          &>span{
          }
        }
      }

      .del-icon-wrap {
        flex: 0 0 10%;
        align-self: stretch;
        font-size: .45rem;
        color: #888;
        text-align: center;
        margin-right: 1%;
        .flex_wrap();

        .iconfont {
          display: block;
          font-size: .45rem;
        }
      }
    }

    .select-item-wrap {
      h3 {
        line-height: .8rem;
        font-weight: 400;
        color: #888;
        flex: 0 0 100%;
      }

      .airport-wrap,
      .car-model,
      .ticket-form {
        margin-top: .2rem;
        padding-bottom: .4rem;
        .border-B();
      }

      .airport-items,
      .car-model,
      .ticket-form {
        .flex_wrap(initial, initial, wrap, initial);

        button {
          .smallBtn();
          box-sizing: border-box;
          background-color: #fff;
          border: 1px solid #888;
          margin: 10px 0 0 10px;
          border-radius: 4px;

          &.active {
            background-color: @primaryColor;
            color: #fff;
            border-color: @primaryColor;
          }
        }
      }
    }

    .goods-amount,
    .link-man-wrap,
    .user-site,
    .phone-num-wrap,
    .date-picker,
    .time-picker,
    .leave-msg {
      padding: 3% 6%;
      .border-B();
    }

    .goods-amount {
      .flex_wrap(space-between, center, nowrap, initial);
      .selector {
        .flex_wrap(center, center, nowrap, initial);
        .radius();
        border: 1px solid #888;

        &>i:first-child {
          border-right: 1px solid #888;
          border-radius: 5px 0 0 5px;
        }

        &>i:last-child {
          border-left: 1px solid #888;
          border-radius: 0 5px 5px 0;
        }

        &>.iconfont {
          text-align: center;
          padding: 0 8px;
          color: #888;
          background-color: #eee;
          align-self: stretch;
          &.disabled {
            background-color: #ddd;
          }
        }

        input {
          border: none;
          outline: none;
          width: 4em;
          align-self: stretch;
          text-align: center;

          &:disabled {
            color: @primaryColor;
            opacity: 1;
            background-color: #fff;
          }
        }
      }
    }

    .link-man-wrap,
    .user-site,
    .phone-num-wrap,
    .date-picker,
    .time-picker,.leave-msg {
      .flex_wrap(initial, center, nowrap, initial);

      &>span:first-child {
        border-right: 1px solid #888;
        padding-right: 8px;
        flex: 0 0 23%;
        text-align: right;
        .text_nowrap();
      }
      input::placeholder{
      }
      input,
      &>span:last-child {
        border: none;
        padding-left: 8px;
        flex: 1;
        line-height: .8rem;
      }
    }

    .mask-footer {
      .flex_wrap(initial, center, initial, initial);

      button {
        .btn();
        .primarybtnColor();
        .border-T();
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/child-components/Mask.vue